import { Injectable, signal } from '@angular/core';
import { CollaboratorDto } from '../../models/collaborator.dto';

@Injectable({ providedIn: 'root' })
export class CollaboratorStore {
  private readonly _collaborator = signal<CollaboratorDto.View | null>(null);

  readonly collaborator = this._collaborator.asReadonly();

  set(collab: CollaboratorDto.View): void {
    this._collaborator.set(collab);
  }

  clear(): void {
    this._collaborator.set(null);
  }
}
